// Shared data model (SPECS §7). Platform-free: no DOM types beyond Blob.

export type CardLanguage = "en" | "ja" | "zh-Hans";

export const CARD_LANGUAGES: readonly CardLanguage[] = ["en", "ja", "zh-Hans"];

export interface CardSet {
  id: string;
  code?: string;
  name: string;
  printedTotal?: number;
  symbolUrl?: string;
  logoUrl?: string;
  releaseDate?: string;
}

export interface Card {
  id: string;
  provider: "tcgdex" | "pokemontcg" | "ptcgdata";
  language: CardLanguage;
  name: string;
  number: string;
  set: CardSet;
  rarity?: string;
  hp?: number;
  imageUrl?: string;
  prices: PriceQuote[];
}

export type Variant = "normal" | "holo" | "reverseHolo" | "firstEdition" | string;

export interface PriceQuote {
  source: "cardmarket" | "tcgplayer";
  currency: "EUR" | "USD";
  variant: Variant;
  trend?: number;
  avg?: number;
  low?: number;
  avg1?: number;
  avg7?: number;
  avg30?: number;
  market?: number;
  updatedAt: string;
  /** Set when the figures came through a fallback provider instead of the card's own one. */
  via?: Card["provider"];
  /** Set when the figures are for another print of the card: the English one for a Chinese card. */
  printLanguage?: CardLanguage;
}

export type Condition = "NM" | "LP" | "MP" | "HP" | "DMG";

export type GradingCompany = "PSA" | "BGS" | "CGC";

/** A graded slab (specs/13). Its value is always the entry's manual value. */
export interface Grading {
  company: GradingCompany;
  /** 1–10 in steps of 0.5; PSA has no 9.5 (FR-91). */
  grade: number;
}

export interface PortfolioEntry {
  id: string;
  cardId: string;
  provider: Card["provider"];
  language: CardLanguage;
  cardSnapshot: Pick<Card, "name" | "number" | "set" | "imageUrl" | "rarity">;
  variant: Variant;
  /** Ignored when `grading` is set (specs/13 FR-93). */
  condition: Condition;
  /** Set for a graded card (specs/13 FR-90). */
  grading?: Grading;
  quantity: number;
  purchasePrice?: number;
  purchaseDate?: string;
  manualValue?: number;
  notes?: string;
  userPhoto?: Blob;
  addedAt: string;
  updatedAt: string;
}
